import cn from "classnames"
import { Fragment } from "react"

import {
  getApplicationSourceDisplay,
  getResourcesNounKey
} from "@/helpers/application-source.helper"

import { Resource } from "./Resource"
import { ResourcesPopover } from "./ResourcesPopover"

import styles from "./Resources.module.scss"

import type { ResourcesComponent } from "."
import { ImageIcon } from "../../icons/Images"

export const Resources: ResourcesComponent = (props) => {
  const { placement } = props
  const isDrawer = placement === "drawer"
  const { inline = isDrawer, popover = isDrawer } = props
  const { resources, t, classes = {} } = props
  const countRelatedResources = (resources?.length || 0) - 1
  const relatedResource = resources?.[1]
  const RelatedApplicationIcon =
    getApplicationSourceDisplay(relatedResource)?.Icon
  const relatedNounKey = getResourcesNounKey(
    resources.slice(1),
    `general.${relatedResource?.type === "Vm" ? "vm" : "image"}`
  )
  const classesResource = {
    container: cn(
      styles.containerResources,
      inline && styles.containerResourcesInline,
      classes.container
    ),
    name: cn(
      !inline && styles.nameResources,
      inline && styles.nameResourcesInline,
      isDrawer && styles.placementDrawer,
      classes.name
    )
  }
  const Wrapper = popover ? ResourcesPopover : Fragment
  const propsWrapper = popover ? props : ({} as any)

  return (
    <Wrapper {...propsWrapper}>
      <div
        className={cn(
          styles.container,
          styles.column,
          inline && styles.section,
          isDrawer && styles.placementDrawer,
          classes.wrapper
        )}
      >
        <Resource classes={classesResource} {...resources[0]} />
        {countRelatedResources > 0 && (
          <span className={cn(styles.section)}>
            {!inline && RelatedApplicationIcon && <RelatedApplicationIcon />}
            {!inline &&
              !RelatedApplicationIcon &&
              relatedResource.imageSource && (
                <ImageIcon imageSource={relatedResource.imageSource} />
              )}
            <span
              className={cn(
                styles.nameRelatedResources,
                inline && styles.inline,
                isDrawer &&
                  cn(styles.placementDrawer, styles.relatedResourcesCount)
              )}
            >{`+${countRelatedResources} ${t(relatedNounKey, { count: countRelatedResources })}`}</span>
          </span>
        )}
      </div>
    </Wrapper>
  )
}
